import { render, staticRenderFns } from "./TelecomHeadBlock.vue?vue&type=template&id=9acbf4c8"
import script from "./TelecomHeadBlock.vue?vue&type=script&lang=js"
export * from "./TelecomHeadBlock.vue?vue&type=script&lang=js"
import style0 from "./TelecomHeadBlock.vue?vue&type=style&index=0&id=9acbf4c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports